import React from "react";

const LABELS = ["Le voyage", "Vos envies", "Personnalisation", "Génération"];

export function StepProgress({ step, total }) {
  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 pt-6">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs uppercase tracking-widest text-[#8B5E34]" style={{ fontFamily: "'Lora', Georgia, serif" }}>
          Étape {step} sur {total}
        </span>
        <span className="text-xs text-[#9A8F86]" style={{ fontFamily: "'Lora', Georgia, serif" }}>
          {Math.round((step / total) * 100)}%
        </span>
      </div>
      <div className="h-1 bg-[#DCD4C6] rounded-none overflow-hidden">
        <div className="h-full bg-[#C17F59] transition-all duration-500" style={{ width: `${(step / total) * 100}%` }} />
      </div>
      <div className="hidden sm:flex justify-between mt-2">
        {LABELS.map((label, i) => (
          <span
            key={i}
            className="text-xs"
            style={{ fontFamily: "'Lora', Georgia, serif", color: i + 1 <= step ? "#8B5E34" : "#DCD4C6" }}
          >
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
